import $ from 'jquery';
import { register } from '../../core/bootstrapper';
import MyOrdersEvents from './MyOrdersEvents';

register('myaccount-orders', function() {
  const myOrdersEvents = new MyOrdersEvents({
    el: $('body')
  });

  $(document).ready(function() {
    myOrdersEvents.executeCookieCallbacks();
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/myAccount/trackingBootstrap.js
 **/